/* eslint-disable no-unused-vars */
import { useRef, useState } from 'react';
import { Modal, Tabs, Table, Card } from 'antd';
import PropTypes from 'prop-types';
import { generateCSV } from 'pages/downloads/DownloadJSONasCSV';

const exportHeaders = [
	{
		key: 'trip_id',
		label: 'Trip ID',
	},
	{
		key: 'driver_name',
		label: 'Driver Name',
	},
	{
		key: 'vehicle_number',
		label: 'Vehicle Number',
	},
	{
		key: 'store_name',
		label: 'Store Name',
	},
	{
		key: 'store_code',
		label: 'Store Code',
	},
	{ key: 'in_time', label: 'In Time' },
	{ key: 'out_time', label: 'Out Time' },
	{ key: 'duration', label: 'Duration' },
];

const StoreColumns = [
	{
		title: 'Store Name',
		dataIndex: 'store_name',
		key: 'name',
	},
	{
		title: 'Store Code',
		dataIndex: 'store_code',
		key: 'store_code',
	},
	{
		title: 'In Time',
		dataIndex: 'in_time',
		key: 'in_time',
	},
	{
		title: 'Out Time',
		dataIndex: 'out_time',
		key: 'out_time',
	},
	{
		title: 'Duration',
		dataIndex: 'duration',
		key: 'duraiton',
	},
];

function ShowRouteMap({ isModalOpen, tripdata, modalState }) {
	const mapRef = useRef(null);
	const [mapKey, setMapKey] = useState(0);
	const [activeTab, setActiveTab] = useState('1');
	const store_data = tripdata?.rows?.store_data;
	const location_data = tripdata?.rows?.location_data;
	const trip_id = store_data && store_data[0]?.trip_id;
	const tabs = [
		{
			key: '1',
			label: 'Store View',
			children: (
				<Table
					columns={StoreColumns}
					dataSource={store_data}
					pagination={{
						position: ['bottomCenter'],
					}}
					rowKey="store_code"
				/>
			),
		},
	];
	function handleClose() {
		modalState(false);
		setMapKey((prev) => prev + 1);
		setActiveTab('1');
	}

	const onChange = (key) => {
		setActiveTab(key);
		if (key === 2) {
			mapRef?.current.flyTo(location_data[0], 13);
		}
	};

	return (
		<Modal
			title="Location History"
			open={isModalOpen}
			width={1000}
			maskClosable={false}
			centered
			okText="Export"
			okButtonProps={{ disabled: !trip_id }}
			onOk={() => generateCSV(exportHeaders, store_data, `Trip-${trip_id}-Timesheet`)}
			cancelText="Close"
			closable
			onCancel={handleClose}
			bodyStyle={{ paddingTop: 0 }}
		>
			<Tabs defaultActiveKey="1" activeKey={activeTab} items={tabs} onChange={onChange} />
		</Modal>
	);
}

export { ShowRouteMap };

ShowRouteMap.propTypes = {
	isModalOpen: PropTypes.bool,
	tripdata: PropTypes.object,
	modalState: PropTypes.func,
};
